import template from './lease-type.jade';
import leaseType from '../../../enums/lease-type';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.leaseType', []).directive('cianAfPriceAndDealTermsLeaseType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService, store) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.leaseTypes = leaseType;

    this.validation = validation(this.form, 'bargainTerms.leaseType', {
      required: 'Укажите тип аренды',
    });

    this.handleChange = () => {
      const state = store.getState();
      const category = selectAnalyticsOfferStatus(state);

      trackRequiredFieldFill(category, 'rent_type');
    };
  },
  controllerAs: 'leaseType',
  template,
})).name;
